import React from 'react'

import { useSelector } from 'react-redux'

import { Link } from 'react-router-dom'

import { FacebookOutlined, Instagram, LinkedIn, Twitter } from '@mui/icons-material'
import { Container, Grid, IconButton, Stack, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  footer: {
    '@global': {
      ul: {
        margin: 0,
        padding: 0,
        listStyle: 'none',
        color: '#fff'
      }
    },
    background: '#212121 !important',
    color: '#fff !important',
    fontFamily: theme.typography.fontFamily,
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    bottom: 0,
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6)
    }

  },
  url: {
    textDecoration: 'none',
    color: '#fff'
  },
  bottom: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row'

  }
}))

const footers = [{
  title: 'Sayfalar',
  urls: [
    { name: 'Ana Sayfa', url: './', display: 'all' },
    { name: 'Giriş', url: './login', display: 'nl' },
    { name: 'Kayıt', url: './register', display: 'nl' },
    { name: 'Ayarlarım', url: './settings', display: 'l' },
    { name: 'İşletme Portal', url: 'https://panel.kolayyolla.app', display: 'all' }
  ]
},
{
  title: 'Bilgilendirme',
  urls: [
    { name: 'Gizlilik Politikası', url: '/policy', display: 'all' },
    { name: 'Kullanıcı Sözleşmesi', url: '/termsofuse', display: 'all' },
    { name: 'Aydınlatma Metni', url: '/clarification', display: 'all' },
    { name: 'KVKK', url: '/kvkk', display: 'all' }
  ]
}
]

const Footer = (props) => {
  const classes = useStyles()
  const auth    = useSelector((state) => state.auth)
  return (
    <footer {...props} className={classes.footer}>
      <Container maxWidth="md">
        <Grid container spacing={4} justifyContent="space-evenly">
          {footers.map((footer) => (
            <Grid item xs={6} sm={3} key={footer.title}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}  gutterBottom>
                {footer.title}
              </Typography>
              <ul>
                {footer.urls.map((item) => {
                  return (item.display === 'all' || (item.display === 'l' && auth.isLoggedIn) || (item.display === 'nl' && !auth.isLoggedIn)) && (
                    <li key={item.name}>
                      <Typography variant="subtitle1" >
                        {!item.url.startsWith('https') ? <Link className={classes.url} to={item.url}>{item.name}</Link> : <a className={classes.url} href={item.url}>{item.name}</a>}
                      </Typography>
                    </li>
                  )
                })}
              </ul>
            </Grid>
          ))}
        </Grid>
        <br/>
        <hr />
        <div className={classes.bottom}>
          <Typography variant="body2" color="textSecondary" align="center" gutterBottom sx={{ color: '#fff' }}>
            {'© '}<Link className={classes.url} color="inherit" to="./">KolayYolla</Link>{' '}{new Date().getFullYear()}
          </Typography>

          <Stack direction="row" spacing={1}>
            <IconButton aria-label="facebook" onClick={() => window.open('https://www.facebook.com/kolayyolla', '_blank') } sx={{ color: '#fff' }} >
              <FacebookOutlined />
            </IconButton>
            <IconButton aria-label="twitter" onClick={() => window.open('https://twitter.com/biriktirharca', '_blank') }  sx={{ color: '#fff' }} >
              <Twitter />
            </IconButton>
            <IconButton aria-label="instagram" onClick={() => window.open('https://www.instagram.com/kolayyolla/', '_blank')} sx={{ color: '#fff' }}>
              <Instagram />
            </IconButton>
            <IconButton aria-label='linkedin' onClick={() => window.open('https://www.linkedin.com/company/76339856/', '_blank')} sx={{ color: '#fff' }}>
              <LinkedIn />
            </IconButton>
          </Stack>
        </div>

      </Container>
    </footer>
  )
}

export default Footer
